export * from './member-list';

export enum LEAD_TYPES {
  COMPANY_GROUP = 'C',
  INDIVIDUAL = 'I',
}

export enum INSURANCE_TYPE {
  LIFE = 'C',
  GENERAL = 'I',
}

export enum LEAD_STATUSES {
  SUSPECT = 'S',
  PROSPECT = 'P',
  QUOTATION = 'Q',
  PROPOSAL_IN_PROGRESS = 'P_I_P',
  PENDING_POLICY = 'P_P',
  COVER_NOTE_ISSUED = 'C_N_I',
  COVER_NOTE_EXPIRED = 'C_N_E',
  POLICY_ISSUED = 'P_I',
  //Renewals
  RENEWAL_REQUEST_SAVED = 'R_R_S',
  RENEWALS_QUOTATION_REQUESTED = 'R_Q_R',
  RENEWALS_QUOTATION_RECEIVED = 'R_Q_RC',
  RENEWAL_INVOICE_ACCEPTED = 'R_I_A',
  RENEWALS_QUOTATION_RE_REQUESTED = 'R_Q_RR',
  RENEWAL_POLICY_ISSUED = 'R_P_I',
  RENEWAL_PAYMENT_PARTIAL = 'R_P_P',
  RENEWAL_PAYMENT_SUCCESSFUL = 'R_P_S',
  RENEWAL_PENDING_APPROVAL_FOR_RATES = 'R_P_A_R',
  RENEWAL_RATES_REJECTED = 'R_R_RJ',
  POLICY_CANCEL = 'Policy Cancel',
}

export enum USER_TYPE {
  CUSTOMER = 'C',
  LEAD = 'L',
}

export enum SOURCE_LEAD_TYPE {
  MARKETING_AGENT = 'MA',
  SELF_LEAD = 'SL',
  DIRECT_LEAD = 'DL',
}

export enum POLICY_CREATED_TYPE {
  MANUAL = 'M',
  AUTO = 'A',
  BULK = 'B',
}

export enum QUOTATION_STATUS {
  SAVED = 'R_SAV',
  RECEIVED = 'Q_REC',
  REQUESTED = 'Q_REQ',
  RE_REQUESTED = 'Q_RE_RQ',
  QUOTATION_RE_REQUESTED = 'Q_R_R',
  PROPOSAL_PENDING = 'P_PEN',
  PROPOSAL_SUBMITTED = 'P_SUB',
  QUOTATION_SHARED_WITH_CUSTOMER = 'Q_SC',
  PROPOSAL_SHARED_WITH_CUSTOMER = 'P_SC',
  PENDING_PAYMENT = 'PA_P',
  POLICY_RETURNED = 'PO_RE',
  POLICY_ACCEPTED = 'PO_A',
  POLICY_CANCELLED = 'PO_C',
  REVIEW_GLOBAL_PARTNER = 'RGP',

  PENDING_APPROVAL_FOR_RATES = 'P_A_R',
  PENDING_PAYMENT_RATES_APPROVED = 'P_P_R_A',
  PENDING_PAYMENT_RATES_MODIFIED = 'P_P_R_M',
  RATES_REJECTED = 'R_RJ',

  // PAYMENT
  PARTIAL_PAID = 'P_P',
  PAYMENT_SUCCESSFUL = 'P_S',
  CLOSED = 'CLS',

  //IGNORED
  IGNORED = 'I', // used in renewal flow where with same insurer
}

export enum POLICY_STATUS {
  IN_FORCED = 'I',
  CANCELLED = 'C',
  LAPSED = 'L',
  DEFAULT = 'D',
  DRAFT = 'DR',
  POLICY_CANCEL = 'Policy Cancel',
  RENEWED = 'R',
}

export enum TYPE_OF_REQUEST_SEND {
  QUOTATION_REQUEST = 'QUOTATION_REQUEST',
}

export enum TYPE_OF_SHARE {
  CUSTOMER = 'CUSTOMER',
  REPORTS_TO = 'REPORTS_TO',
  LIAISING = 'LIAISING',
  CLAIM_HANDLER = 'CLAIM_HANDLER',
  ACCOUNT_HANDLER = 'ACCOUNT_HANDLER',
}

export enum QUOTATION_ANALYSIS_CREATED_TYPE {
  AUTOMATICALLY = 'A',
  MANUALLY = 'M',
}

export enum QUOTATION_ANALYSIS_STATUS {
  PROCESSING = 'P',
  GENERATED = 'G',
  FAILED_AI = 'FA',
  FAILED_UPLOAD = 'FU',
  UPLOADED = 'U',
}
